import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import { computed, defineComponent, nextTick, reactive, ref, toRefs } from "vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import useCurrentInstance from "@/hooks/useCurrentInstance";
import Process from "@/components/WriteProcess/index.vue";
import UpLoadImg from "@/components/UpLoadImg/index.vue";
import Approve from "@/components/Approval/index.vue";
import { ArrowRight } from "@element-plus/icons";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "Add",
  components: {
    Head: Head,
    UpLoadImg: UpLoadImg,
    ArrowRight: ArrowRight,
    Process: Process,
    Approve: Approve
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = useRouter();
    var ruleFormRef = ref(); //表单dom

    var PublishApproveRef = ref(); //选择审批人的dom

    var form = reactive({
      typeId: null,
      street: "",
      personName: "",
      mobile: "",
      approvalId: null,
      approvalOrgIds: null,
      description: "",
      imgUrls: ""
    }); // 审批人姓名

    var approvalName = ref(""); // 表单dom

    var RefForm = ref(); // 过程描述组件

    var RefProcess = ref();
    var list = reactive({
      TypeList: [{
        typeId: "",
        typeName: ""
      }]
    });
    var getApprovaName = computed(function () {
      return /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId) {
          var res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getEvaluationUser"]({
                    userId: userId
                  });

                case 2:
                  res = _context.sent;

                  if (!(res.code == 0)) {
                    _context.next = 5;
                    break;
                  }

                  return _context.abrupt("return", res.data.userName);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    });
    var rules = reactive({
      typeId: [{
        required: true,
        message: "请选择难事类型",
        trigger: "blur"
      }],
      street: [{
        required: true,
        message: "请填写上报街道",
        trigger: "blur"
      }],
      personName: [{
        required: true,
        message: "请填写联系人姓名",
        trigger: "blur"
      }],
      mobile: [{
        required: true,
        message: "请填写联系方式",
        trigger: "blur"
      }, {
        validator: MobileValidator,
        trigger: "blur"
      }],
      approvalId: [{
        required: true,
        message: "请选择审批人",
        trigger: "change"
      }]
    }); // 联系方式校验

    function MobileValidator(rule, value, callback) {
      var reg_contractsMobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      if (!reg_contractsMobile.test(value)) {
        callback(new Error('请输入正确的联系方式'));
      } else {
        callback();
      }
    } // 返回


    function back() {
      router.back();
    } // 获取分类


    getTypeList();

    function getTypeList() {
      return _getTypeList.apply(this, arguments);
    } // 点击选择审批人按钮


    function _getTypeList() {
      _getTypeList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getTypeList"]();

              case 2:
                res = _context4.sent;

                if (res.code == 0) {
                  list.TypeList = res.data;
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getTypeList.apply(this, arguments);
    }

    function getApprovalId() {
      nextTick(function () {
        PublishApproveRef.value.select({
          dialogVisible: true,
          radioVal: {
            id: form.approvalId,
            orgId: form.approvalOrgIds
          }
        });
      });
    } // 选择审批人获得返回值


    function approvalPepole(item) {
      form.approvalId = item.id;
      form.approvalOrgIds = item.orgId;
      approvalName.value = item.name;
    } // 校验


    function verify() {
      if (!RefForm.value) return;
      return new Promise(function (resolve) {
        RefForm.value.validate( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid, fields) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (valid) {
                      resolve("");
                    } else {
                      console.log("error", fields);
                    }

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x2, _x3) {
            return _ref2.apply(this, arguments);
          };
        }());
      });
    }

    function submit() {
      var a = verify();
      var b = RefProcess.value.verify();
      Promise.all([a, b]).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(result) {
          var a, res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  a = result[1];
                  form.imgUrls = a.imgs;
                  form.description = a.content;
                  _context3.next = 5;
                  return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["appDifficulty"](form);

                case 5:
                  res = _context3.sent;

                  if (res.code == 0) {
                    ElMessage.success("添加成功");
                    setTimeout(function () {
                      router.push({
                        path: '/personal/problemReporting'
                      });
                    }, 300);
                  }

                case 7:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (e) {
        console.log(e);
      });
    }

    return _objectSpread(_objectSpread({
      form: form,
      ruleFormRef: ruleFormRef,
      getApprovaName: getApprovaName,
      RefProcess: RefProcess,
      RefForm: RefForm,
      PublishApproveRef: PublishApproveRef,
      approvalName: approvalName,
      submit: submit,
      back: back,
      getApprovalId: getApprovalId,
      approvalPepole: approvalPepole
    }, toRefs(list)), {}, {
      rules: rules
    });
  }
});